import { render } from "./activityManage.vue?vue&type=template&id=45b0927e&scoped=true&ts=true"
import script from "./activityManage.vue?vue&type=script&lang=ts"
export * from "./activityManage.vue?vue&type=script&lang=ts"

import "./activityManage.vue?vue&type=style&index=0&id=45b0927e&lang=less&scoped=true"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45b0927e"]])

export default __exports__